const prefix = 'policy-details-common-info';

const SET_POLICY_NAME = `${prefix}/SET_POLICY_NAME`;

// eslint-disable-next-line import/prefer-default-export
export { SET_POLICY_NAME };
